import { Component, Host, h, Prop, State } from '@stencil/core';
import { getCSSVal } from './../../../utils/utils';
import state from './../../../state/cta-price';

@Component({
  tag: 'afs-cta-game',
  styleUrl: 'afs-cta-game.sass',
  shadow: true,
})
export class AfsCtaGame {

  contentDiv! : HTMLElement;
  cardsSlot! : HTMLElement;
  paymentSlot! : HTMLElement;

  @Prop() faqHref : string;
  @Prop() rulesHref : string;
  @Prop() winnersHref : string;
  // @Prop() weekCount : number = 52;
  @Prop() heading : string = "WEEK 52";
  @Prop() transitionSpeed : number = 0.8;
  @Prop() selectedCardBackgroundColor : string;
  @Prop() selectedCardBorderColor : string;
  @Prop() selectedCardColor : string;
  @Prop() static : boolean = false;
  @State() currentSlot : 'cards' | 'payment' = 'cards';
  @State() cardInfo : any = {
    src: '',
    noNumber: false,
    noBorder: false,
  }

  async componentDidLoad() {
    const afsCtaCards = document.querySelectorAll('#afs-cta-game [slot="cards"] .afs-cta-cards');
    afsCtaCards.forEach((card, index) => {
      card.setAttribute('number', `${index + 1}`);

      if (this.static) {
        card.setAttribute('disabled', 'true');
        return;
      };

      card.addEventListener('click', async (e) => {
        state.CTASelectedCardPosition = index + 1;
        const cardElement : any = e.target;
        this.cardInfo = {
          src: cardElement.src,
          noNumber: cardElement.noNumber,
          noBorder: cardElement.noBorder,
        }
        await this.transitionScreen(this.cardsSlot, this.paymentSlot);
        this.currentSlot = 'payment';
      })
    })
  }

  transitionScreen(currentScreen :HTMLElement, targetScreen : HTMLElement) {
    return new Promise(res => {
      this.contentDiv.style.pointerEvents = 'none';
      const currentScreenHeight = parseFloat(getCSSVal(currentScreen, 'height'));
      this.contentDiv.style.height = `${currentScreenHeight}px`;
      setTimeout(() => this.contentDiv.style.height = '0px', 10)
      setTimeout(() => {
        currentScreen.style.display = "none";
        targetScreen.style.display = 'block';
        const targetScreenHeight = parseFloat(getCSSVal(targetScreen, 'height'));
        this.contentDiv.style.height = `${targetScreenHeight}px`
      }, 800);
      setTimeout(() => {
        this.contentDiv.style.height = "auto";
        this.contentDiv.style.pointerEvents = 'auto';
        res(true);
      }, 1600);
    });
    
  }

  render() {
    return (
      <Host id="afs-cta-game">
        <div class="triangle-top triangle"></div>
        <afs-section id="afs-cta-game-section" class="main-content" background-color="#E9E7E7" py-0>
          
          <div 
            class="content" 
            ref={ el => this.contentDiv = el as HTMLElement }
            style={{ transition: `${this.transitionSpeed}s ease-in-out` }}
          >
            <div class="cards" ref={ el => this.cardsSlot = el as HTMLElement }>
              <div class="top-bar">
                <div>
                </div>
                <h1>{ this.heading }</h1>
                <afs-nav>
                  <li><afs-button color="#000000" background-color="#FFFFFF" href={ this.faqHref } size="s" size-tablet="xs" thin>FAQs</afs-button></li>
                  <li><afs-button color="#000000" background-color="#FFFFFF" href={ this.rulesHref } size="s" size-tablet="xs" thin>RULES</afs-button></li>
                  <li><afs-button color="#000000" background-color="#FFFFFF" href={ this.winnersHref } size="s" size-tablet="xs" thin>WINNERS</afs-button></li>
                </afs-nav>
              </div>
              <slot name="cards"></slot>
            </div>
            <div class="payment" ref={ el => this.paymentSlot = el as HTMLElement }>
              <div class="card-reselect">
                <h3>You Have Selected</h3>
                <afs-cta-card 
                  style={{pointerEvents: 'none !important'}} 
                  number={state.CTASelectedCardPosition}
                  background-color={this.selectedCardBackgroundColor}
                  color={this.selectedCardColor}
                  border-color={this.selectedCardBorderColor}
                  src={this.cardInfo.src && this.cardInfo.src !== "" && this.cardInfo.src}
                  no-border={this.cardInfo.noBorder ? true : false}
                  no-number={this.cardInfo.noNumber ? true : false}
                ></afs-cta-card>
                <afs-button 
                  href="#afs-cta-game"
                  size="m" 
                  size-tablet="sm"
                  thin
                  color="#FFFFFF" 
                  background-color="#222222"
                  onClick={async () => {
                    this.currentSlot = 'cards'; 
                    await this.transitionScreen(this.paymentSlot, this.cardsSlot); 
                }}>RESELECT YOUR CARD</afs-button> 
              </div>
              <slot name="payment"></slot>
            </div>
          </div>
        </afs-section>
        <div class="triangle-bottom triangle"></div>
      </Host>
    );
  }

}
